// Must stay the first import: it starts analytics before any other module is
// evaluated (see the comment in that file).
import './main/utils/analytics/bootstrap';

import * as React from 'react';
import ReactDOM from 'react-dom/client';
import { App } from './main/main';
import { initBolt } from './lib/utils/bolt';
import { captureExchangeFailureOnce } from './main/utils/analytics/analytics.utils';
import { FailureStep } from './main/utils/analytics/events';

import { i18n } from './i18n/i18n';
import './index.css';

try {
  document.documentElement.dir = i18n.dir();
  document.documentElement.lang = i18n.language;
} catch (error) {
  captureExchangeFailureOnce(FailureStep.Bootstrap, error, { stage: 'i18n' });
}

try {
  initBolt();
} catch (error) {
  captureExchangeFailureOnce(FailureStep.Bootstrap, error, {
    stage: 'initBolt',
  });
}

try {
  ReactDOM.createRoot(document.getElementById('app') as HTMLElement).render(
    <App />
  );
} catch (error) {
  captureExchangeFailureOnce(FailureStep.Render, error);
}
